import Swiper from 'swiper/swiper-bundle';

export function mvSlider() {
	let sliderThumbnail = new Swiper(".slider-thumbnail", {
		slidesPerView: 5, // サムネイルの枚数
		spaceBetween: 10, //スライド間の距離を16pxに
		breakpoints: {
			768: {
				spaceBetween: 24, //スライド間の距離を16pxに
			},
		},
	});
	let mvSlider = new Swiper('.j-mvslider', {
		navigation: {
			nextEl: ".j-mvslider-next",
			prevEl: ".j-mvslider-prev"
		},
		loop: true, //繰り返しをする
		// centeredSlides: true, //アクティブなスライドを中央に表示
		slidesPerView: 1, //スライダーのコンテナ上に2枚同時に表示
		// slidesPerView: 3.5, //スライダーのコンテナ上に2枚同時に表示
		// spaceBetween: 24, //スライド間の距離を16pxに
		speed: 600, //スzライドの推移時間を600msに
		// autoplay: {
			// 	delay: 3000 //3秒ごとにスライダを切り替える
			// },
		thumbs: {
			swiper: sliderThumbnail,
		},
		breakpoints: {
			768: {
				slidesPerView: 1, //スライダーのコンテナ上に2枚同時に表示
				// spaceBetween: 32, //スライド間の距離を16pxに
			},
		},

	});

}